(function () {
  const GIFT_WRAP_PROPERTY_NAME = 'Confezione regalo';
  const GIFT_WRAP_PROPERTY_VALUE = 'SÌ';
  const GIFT_WRAP_VARIANT_ID = 56663001923970;

  const originalFetch = window.fetch.bind(window);
  let suppress = false; // evita che le NOSTRE chiamate ri-triggerino la logica

  window.fetch = async function (...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    const response = await originalFetch(...args);

    if (suppress) return response; // le nostre mutazioni non vanno processate qui

    const isAdd = url.includes('/cart/add') && config && config.method === 'POST';
    const isChange = url.includes('/cart/change') && config && config.method === 'POST';

    if (isAdd) {
      response.clone().json().then((data) => {
        const addedItems = data.items ? data.items : [data];
        addedItems.forEach((item) => {
          const props = item.properties || {};
          if (props[GIFT_WRAP_PROPERTY_NAME] === GIFT_WRAP_PROPERTY_VALUE) {
            addGiftWrapFor(item.key);
          }
        });
      }).catch((e) => console.error('[GiftWrap] parse /cart/add fallito', e));
    }

    if (isChange) handlePossibleRemoval(config);

    return response;
  };

  // GET di lettura: non serve farlo vedere all'app
  async function getCart() {
    const res = await originalFetch('/cart.js');
    return res.json();
  }

  // mutazione "visibile" a CartyLabs (passa dal window.fetch con il suo hook)
  async function cartMutate(endpoint, payload) {
    suppress = true;
    try {
      return await window.fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    } finally {
      suppress = false;
      nudgeRefresh(); // fallback, nel caso l'app non si aggiorni da sola
    }
  }

  async function addGiftWrapFor(lineKey) {
    const cart = await getCart();
    const already = cart.items.some(
      (i) => i.properties && i.properties['_gift_wrap_for'] === lineKey
    );
    if (already) return;
    await cartMutate('/cart/add.js', {
      items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: 1, properties: { _gift_wrap_for: lineKey } }],
    });
  }

  async function handlePossibleRemoval(config) {
    try {
      const body = JSON.parse(config.body);
      if (body.quantity !== 0) return;
      const cart = await getCart();
      const stillThere = cart.items.some((i) => i.key === body.id || i.id === body.id);
      if (stillThere) return;
      const orphan = cart.items.find(
        (i) => i.properties && i.properties['_gift_wrap_for'] &&
          !cart.items.some((x) => x.key === i.properties['_gift_wrap_for'])
      );
      if (orphan) await cartMutate('/cart/change.js', { id: orphan.key, quantity: 0 });
    } catch (e) { /* body non pertinente */ }
  }

  // Fallback: prova i trigger di refresh più comuni (document + window)
  async function nudgeRefresh() {
    const render = async () => {
      try { if (window.fcsb?.fetchCart) await fcsb.fetchCart(); } catch (e) { }
      try { if (window.fcsb?.refetchStates) await fcsb.refetchStates(); } catch (e) { }
    };
    // il carrello (Shopify) ha una confezione regalo?
    const cartHasGift = async () => {
      try {
        const c = await (await originalFetch('/cart.js')).json();
        return c.items.some(i => i.properties && i.properties['_gift_wrap_for']);
      } catch (e) { return null; }
    };
    // il drawer la sta mostrando?
    const drawerHasGift = () =>
      !!document.querySelector('[data-cl="minicart-product-title"][title*="Confezione regalo" i]');

    const want = await cartHasGift();      // stato "vero" da raggiungere
    let stable = 0;
    for (let i = 0; i < 8; i++) {          // max ~1,5s
      await render();
      await new Promise(r => requestAnimationFrame(() => setTimeout(r, 120)));
      if (want === null || drawerHasGift() === want) {
        if (++stable >= 2) break;          // 2 conferme di fila → stop
      } else stable = 0;                     // fcsb ha reso lo stato vecchio → ri-affermo
    }
  }
})();